var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['input-container', {
      'input-required': _vm.requiredMask
    }, {
      'input-required-only': _vm.required && !_vm.requiredMask
    }, {
      'input-with-label': _vm.label
    }, _vm.containerClass]
  }, [_vm.label ? _c('label', {
    class: ['input-label', _vm.labelClass],
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n    "), _vm.requiredMask ? _c('span', {
    staticClass: "input-label-required-mask"
  }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _c('input', _vm._b({
    class: _vm.customClass,
    attrs: {
      "disabled": _vm.disabled,
      "id": _vm.id,
      "maxlength": _vm.maxlength,
      "max": _vm.max,
      "min": _vm.min,
      "multiple": _vm.multiple,
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "step": _vm.step,
      "type": _vm.type
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.handleInput
    }
  }, 'input', _vm.$attrs, false)), _vm.requiredMask && !_vm.label ? _c('span', {
    staticClass: "input-required-mask"
  }, [_vm._v("*")]) : _vm._e(), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }